// extracted by mini-css-extract-plugin
module.exports =  {"container_redesigned":"a10a3f92e9--container_redesigned--jvEcm","container":"a10a3f92e9--container--QW8o8","title":"a10a3f92e9--title--zl0nt","link":"a10a3f92e9--link--Vjqgm"};